export default __webpack_public_path__ + "static/media/wordpress-logo-transparent-white.779a1813.png";